import 'tailwindcss/base.css';

// Allows us to keep the state given by React Context on page change
import React from 'react';
import GlobalContextProvider from './src/context/global-context-provider';
import { initAnalytics, trackPageView } from './src/utils/analytics';

Array.prototype.compact = function <T>(this: (T | null | undefined)[]): T[] {
  return this.filter((item) => item != null && item !== undefined) as T[];
};

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <GlobalContextProvider>{element}</GlobalContextProvider>
);

// force page reload when it has been updated
export const onServiceWorkerUpdateReady = () => window.location.reload();

// Load gtag if the user had already consented during a previous visit.
export const onClientEntry = () => {
  initAnalytics();
};

// Gatsby is an SPA: we manually track each route change.
// (no-op if consent has not been granted)
export const onRouteUpdate = ({ location }: { location: Location }) => {
  trackPageView(location.pathname + location.search);
};